import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Sidenav from "components/Layout/Sidenav";
import Header from "components/Layout/Header";
import Footer from "components/Layout/Footer";
import { Route, Routes, useLocation } from "react-router-dom";
import Overview from "routes/app/routes/overview/components/Overview";
import APPCONFIG from "constants/appConfig";
import axios from "axios";
import Loader from "components/Loading/Loader";
import { getUser, redirectAndSaveState, setUser } from "services/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  appdataSelector,
  appdata_clearActive,
  appdata_setSnackbar,
  fetchAppdata
} from "reducers/appdata/appdata";
import Create from "routes/app/routes/create";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Change from "routes/app/routes/change/components/Change";
import Extend from "routes/app/routes/extend/components/Extend";
import Reactivate from "routes/app/routes/reactivate/components/Reactivate";
import RequestDetails from "routes/app/routes/request/components/RequestDetails";

import Modal from "@mui/material/Modal";
import logo from '../../../assets/images/besi_logo.png';
import Button from "@mui/material/Button";
function MainApp(props) {
  console.log("Mainapp - init");
  const dispatch = useDispatch();
  const appdata = useSelector(appdataSelector);
  const [hasLogin, setHasLogin] = useState(false);
  const location = useLocation();

  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => {
     setOpenModal(false);
  };

  useEffect(() => {
    // execute on location change
    console.log("Location changed!", location.pathname);

    if (location.pathname.includes("/app/vendor")){
      console.log("location - vendor ");

    }
    else{
      console.log("location - other ");
      dispatch(appdata_clearActive())
    }


  }, [location]);

  const getData = () => {
    dispatch(fetchAppdata());
  };
  const getMe = () => {
    console.log("getMe");
    axios
      .get(APPCONFIG.host + "api/me", {
        withCredentials: true,
        timeout: APPCONFIG.axiosTimeout
      })
      .then(res => {
        console.log("MainApp - getme - got user", res.data);
        setUser({ ...getUser(), ...res.data });
        if (res.data.employeeId) {
          console.log("has login!");
          setHasLogin(true);
        } else {
          console.log("has NO login!");
          if (hasLogin) setHasLogin(false);
          // @TODO employeeId is not set what should we do?
          window.location.href =
            APPCONFIG.appFrontendHostname + "#/user/notallowed";
        }
      })
      .catch(error => {
        console.error(error);
        if (
          error.response &&
          error.response.status &&
          error.response.status === 403
        ) {
          // user not in groups
          window.location.href =
            APPCONFIG.appFrontendHostname + "#/user/notallowed";
        } else {
          redirectAndSaveState(error);
        }
        // handle error
      });
  };

  useEffect(() => {
    console.log("Mainapp - init", location);

    const isRoot = location && location.pathname === "/" ? true : false;
    if (isRoot) {
      console.log("MainApp is root, frontend:" + APPCONFIG.appFrontendHostname);
      let url = APPCONFIG.appFrontendHostname + "#/app/overview";
      window.location.href = url;
    }

    getMe();

    getData();

    sessionStorage.removeItem("besiUser4");

    let sesionId = localStorage.getItem("laravelSession");
    if (sesionId) {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "laravelSession"
      );
    }

    if (!openModal) {
      const currentDate = new Date();
      const startDate = new Date('2025-05-19');
      const endDate = new Date('2025-05-23');

      if (currentDate >= startDate && currentDate <= endDate) {
        setOpenModal(true);
      }

    }


  }, []);

  if (!hasLogin || !appdata.loaded) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center h-100">
        <div className="row">
          <div className="col-12">
            <Loader></Loader>
          </div>
        </div>

        {/* {appdata.error && (
          <div className="row">
            <div className="col-12">{appdata.error}</div>
          </div>
        )} */}
      </div>
    );
  }

  return (
    <div className="main-app-container">

<Modal
        onClick={handleCloseModal}
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <div className="modal-content" style={{
          width: window.innerWidth <= 768 ? '90%' : '50%',
          height: window.innerWidth <= 768 ? '90%' : '50%',
          margin: 'auto',
          border: '2px solid #008752',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          backgroundColor: 'white',
          borderRadius: '10px'
        }}>
          <img className="mb-4"src={logo} alt="BESI" />
          <h2 id="simple-modal-title">Important Notice</h2>
          <br></br>
          <p id="simple-modal-description">
            <span style={{color: 'red'}}><b>This app will be offline from the 22nd of May to the 26th of May.</b></span>
            <br></br>
            <br></br>
          </p>

          <Button variant="contained" onClick={handleCloseModal}>
            Close
          </Button>
        </div>
      </Modal>

      <Sidenav />
      <section id="page-container" className="app-page-container">
        <Header />
        <div className="app-content-wrapper">
          <div className="app-content">
            <div className="h-100">
              <Routes>
                <Route path="/overview" element={<Overview />} />
                <Route path="/vendor/:reqID" element={<RequestDetails />} />
                <Route path="/createVendor" element={<Create />} />
                <Route path="/changeVendor" element={<Change />} />
                <Route path="/extendVendor" element={<Extend />} />
                <Route path="/reactivateVendor" element={<Reactivate />} />

                <Route
                  //path={`${match.url}/exception`}
                  path="/exception"
                  element={<exception />}
                />
              </Routes>

              <Snackbar
                className="mt-6"
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={appdata.snackbar.open}
                onClose={() => {
                  dispatch(appdata_setSnackbar({ open: false }));
                }}
                key={"ilovesnacks"}
                autoHideDuration={5000}
              >
                <Alert severity={appdata.snackbar.severity}>
                  {appdata.snackbar.message}
                </Alert>
              </Snackbar>
            </div>
          </div>
          <Footer />
        </div>
      </section>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => ({});

export default connect(mapStateToProps)(MainApp);
